export enum SampleType {
  SurfaceMicrobial = "SurfaceMicrobial",
  AirMicrobial = "AirMicrobial",
}

export enum SamplingMethod {
  aLK = "aLK",
  pLK = "pLK",
  AK = "AK",
}

export enum ProcedureType {
  RLT2N = "2NRLT",
  RLT1N = "1NRLT",
}

export enum GrowthMedium {
  Caso = "Caso",
  Malt = "Malt",
  DG18 = "DG18",
}

export enum Testnorm {
  VDI = "VDI6022-1:2018-01",
  DIN = "DINEN17141:2021-02",
  EU = "EU-GMP:2022-08",
}

export interface SamplingMetadata {
  sampledBy: string;
  sampleTakers: string;
  sampleDate: string; // ISO-Date-String (entspricht time.Time in Go)
  testnorm: Testnorm;
}

export interface ActiveAirMicrobialMetadata {
  samplingVolume: number;
  airSamplerHoleCount: number;
  airSamplerDescription: string;
  airSamplerId: string;
  airSamplerOriginalId: string;
}
